import { useState, type FunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import { useMenuVisibility } from '@/domains/productDiscovery/HeaderLeonidas/hooks/useMenuVisibility';
import { MenuForSEO } from '@/productDiscovery/HeaderLeonidas/components/Menu/MenuForSEO.lazy';
import { MenuInteractive } from '@/productDiscovery/HeaderLeonidas/components/Menu/MenuInteractive';
import type { MenuCategory } from '@/productDiscovery/HeaderLeonidas/interfaces/MenuTree.model';
import { selectMenuCategories } from '@/productDiscovery/HeaderLeonidas/selectors/selectors';
import type { SpartacuxProductDiscoveryDomainState } from '@/productDiscovery/productDiscovery.model';

export const Menu: FunctionComponent = () => {
  const isMenuVisible = useMenuVisibility();
  const [menuForSeoInnerHtml, setMenuForSeoInnerHtml] = useState('');

  const categories = useSelector<
    SpartacuxProductDiscoveryDomainState,
    MenuCategory[] | undefined
  >(selectMenuCategories);

  /*
   * Sometimes (for example in category pages) the hydration occurs even if the MenuForSEO
   * component should never be hydrated.
   * This is a workaround to get the innerHTML of the menu (coming for the server side) and
   * inject it in the menu when this hydration occurs.
   */
  if (typeof window !== 'undefined' && menuForSeoInnerHtml === '') {
    const element = window.document?.getElementById('menu-SEO');
    if (element?.innerHTML !== undefined) {
      setMenuForSeoInnerHtml(element.innerHTML);
    }
  }

  return isMenuVisible ? (
    <MenuInteractive />
  ) : (
    <MenuForSEO categories={categories} innerHtml={menuForSeoInnerHtml} />
  );
};

Menu.displayName = 'Menu';
